/* ---------------------------------
-----  dimension variables --------
---------------------------------- */
/* ------  standard elements padding & margin  ------- */
/* spacing */
/**
**  Official Font sizes
------------------------------- */
/**
** Line-heights
------------------------------- */
/*
  Mixin to progressively-enhance :focus-visible, keeping :focus where not supported
  Add an arbitrary list of selectors into the arguments, and the styling in the block.
  I you pass no selectors to the mixin the parent ("ampersand") operator is used instead.

  There are two mixins:
  - focus-visible: a generic focus-visible, giving you "slots" to decide what to render for :focus, :focus reset, and :focus-visible
  - focus-visible-outline: a focus-visible, which only resets the outline. If you don't need more custom resets, use this one!

  Use focus-visible:
  The key thing here is checking which slot is being rendered.
  For example, you can reset box-shadow here, or anything else.

  @include focus-visible using ($slot) {
      @if $slot == focus {
          outline: 2px solid transparent;
          box-shadow: 0 0 0 4px blue;
      }
      @if $slot == focusReset {
          box-shadow: none;
      }
      @if $slot == focusVisible {
          box-shadow: 0 0 0 4px blue;
      }
  }

  Use focus-visible-outline:
  @include focus-visible-outline("button", "a[href]") {
      outline: 2px solid blue;
  }

  Resulting CSS (compressed):

  button:focus,
  a[href]:focus {
      outline: 2px solid blue;
  }

  button:focus:not(:focus-visible),
  a[href]:focus:not(:focus-visible) {
      outline: none;
  }
  button:focus-visible,
  a[href]:focus-visible {
      outline: 2px solid blue;
  }
*/
/**
@prop --ux-input-label-color: text color of the label
@prop --ux-input-label-font-size: font-size of the label
@prop --ux-input-label-font-weight: font-weight of the label
@prop --ux-input-label-line-height: line-height of the label
@prop --ux-input-label-padding: inner padding of the label
@prop --ux-input-label-margin: outer margin of the label
@prop --ux-input-label-spacing: gap size between label elements
@prop --ux-input-label-text-transform: text-transform of the label
@prop --ux-input-label-required-symbol: symbol that is displayed after the label text if required is `true`
 */
.ux-input-label {
  display: block;
}

ux-input-label .ux-label {
  box-sizing: border-box;
  display: block;
  font-family: var(--ux-font);
  font-size: var(--ux-input-label-font-size, var(--ux-label-font-size));
  font-weight: var(--ux-input-label-font-weight, var(--ux-label-font-weight));
  line-height: var(--ux-input-label-line-height, var(--ux-label-line-height));
  margin: var(--ux-input-label-margin, var(--ux-label-margin));
  padding: var(--ux-input-label-padding, var(--ux-label-padding));
  text-transform: var(--ux-input-label-text-transform, var(--ux-label-text-transform));
  /* stylelint-disable selector-max-compound-selectors */
  /* stylelint-enable selector-max-compound-selectors */
}
ux-input-label .ux-label .ux-label__text,
ux-input-label .ux-label .ux-label__label-slot,
ux-input-label .ux-label .ux-label__error-msg,
ux-input-label .ux-label .ux-label__info,
ux-input-label .ux-label > * {
  display: inline;
  vertical-align: top;
}
ux-input-label .ux-label .ux-label__text + * {
  margin-left: var(--ux-input-label-spacing, var(--ux-label-spacing));
}
ux-input-label .ux-label--required .ux-label__text::after {
  content: var(--ux-input-label-required-symbol);
}
ux-input-label .ux-label--empty {
  padding: var(--ux-input-label-padding-empty);
}